/* DER Learn: first-order offer behaviour (sections/der-learn-offer.liquid).
 *
 * What it does, in order:
 *   1. Counts an impression the first time each offer element is at least half visible.
 *   2. On "Get My 20% Off": applies Shopify's own discount link in the background
 *      (/discount/CODE sets the discount_code cookie that checkout reads), marks the cart
 *      with an attribute so the order can be attributed later, reveals the code with a
 *      Copy Code fallback, and scrolls to the product module.
 *   3. Remembers the interaction for this tab (sessionStorage) and, once it has happened,
 *      reports every add to cart on the page as an offer-assisted add to cart.
 *
 * Every event goes to four places when they exist: gtag (GA4), the GTM dataLayer,
 * Shopify customer events (Shopify.analytics.publish, for a custom pixel) and Clarity.
 * Event names: dl_offer_impression, dl_offer_click, dl_offer_applied, dl_offer_copy,
 * dl_offer_add_to_cart. Every event carries offer_id, discount_code, offer_variant.
 *
 * Progressive enhancement: with this file blocked, the button is still a working
 * /discount/CODE?redirect=... link and the code still applies at checkout.
 */
(function () {
  'use strict';
  if (window.__dlOfferInit) return;
  window.__dlOfferInit = true;

  var cfgEl = document.querySelector('script[data-dl-offer-config]');
  var cfg = {
    ga4: (cfgEl && cfgEl.getAttribute('data-ga4')) || '',
    attrKey: (cfgEl && cfgEl.getAttribute('data-attr-key')) || 'first_order_offer',
    msgApplied: (cfgEl && cfgEl.getAttribute('data-msg-applied')) || 'Your discount is saved and will apply automatically at checkout.',
    msgFallback: (cfgEl && cfgEl.getAttribute('data-msg-fallback')) || 'Use this code at checkout.'
  };
  var STORE_KEY = 'dlOffer:interacted';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function readState() {
    try { return JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; }
  }
  function writeState(s) {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) {}
  }

  function track(name, params) {
    var ev = 'dl_offer_' + name;
    var p = Object.assign({ page_path: location.pathname }, params || {});
    try { if (typeof window.gtag === 'function') { window.gtag('event', ev, cfg.ga4 ? Object.assign({ send_to: cfg.ga4 }, p) : p); } } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: ev }, p)); } catch (e) {}
    try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') { window.Shopify.analytics.publish(ev, p); } } catch (e) {}
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'dl_offer', name);
        if (name === 'click' || name === 'add_to_cart') window.clarity('event', ev);
      }
    } catch (e) {}
  }

  function baseParams(offerEl) {
    return {
      offer_id: offerEl.getAttribute('data-dl-offer-id') || 'first-order',
      discount_code: offerEl.getAttribute('data-dl-offer-code') || '',
      offer_variant: offerEl.getAttribute('data-dl-offer-variant') || 'full'
    };
  }

  /* ---------- 1. Impressions ---------- */
  var offers = Array.prototype.slice.call(document.querySelectorAll('[data-dl-offer]'));
  if ('IntersectionObserver' in window) {
    var seen = new WeakSet();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting || seen.has(en.target)) return;
        seen.add(en.target);
        io.unobserve(en.target);
        track('impression', baseParams(en.target));
      });
    }, { threshold: 0.5 });
    offers.forEach(function (el) { io.observe(el); });
  } else {
    offers.forEach(function (el) { track('impression', baseParams(el)); });
  }

  /* ---------- 2. The click ---------- */
  function hasDiscountCookie(code) {
    try {
      var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
      return !!(m && decodeURIComponent(m[1]).toUpperCase() === code.toUpperCase());
    } catch (e) { return false; }
  }

  function applyDiscount(code) {
    // Shopify's discount endpoint answers with a redirect and sets the discount_code cookie.
    // Redirecting to /cart.js keeps the follow-up response tiny.
    var url = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js');
    return fetch(url, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok || r.type === 'opaqueredirect'; })
      .catch(function () { return false; });
  }

  function markCart(code, offerId) {
    var attrs = {};
    attrs[cfg.attrKey] = code + ' | ' + offerId + ' | ' + location.pathname;
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }

  function showStatus(offerEl, text, isError) {
    var st = offerEl.querySelector('[data-dl-offer-status]');
    if (!st) return;
    st.textContent = text;
    st.classList.toggle('is-error', !!isError);
    st.hidden = false;
  }
  function revealCode(offerEl) {
    var box = offerEl.querySelector('[data-dl-offer-code-box]');
    if (box) box.hidden = false;
  }
  function scrollToPicks(offerEl) {
    var target = offerEl.getAttribute('data-dl-offer-variant') === 'reminder'
      ? null
      : (offerEl.parentNode && offerEl.parentNode.querySelector('[data-dl-offer-picks]'));
    if (!target) return;
    try { target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }); } catch (e) { target.scrollIntoView(); }
  }

  document.addEventListener('click', function (e) {
    var cta = e.target.closest && e.target.closest('[data-dl-offer-cta]');
    if (!cta) return;
    var offerEl = cta.closest('[data-dl-offer]');
    if (!offerEl) return;
    e.preventDefault();

    var code = offerEl.getAttribute('data-dl-offer-code') || '';
    var params = baseParams(offerEl);
    track('click', params);
    writeState({ code: code, offerId: params.offer_id, at: Date.now() });

    cta.setAttribute('aria-busy', 'true');
    cta.classList.add('is-busy');

    applyDiscount(code).then(function (ok) {
      var cookieOk = hasDiscountCookie(code);
      var applied = ok || cookieOk;
      track('applied', Object.assign({ method: cookieOk ? 'cookie' : (ok ? 'fetch' : 'failed'), success: applied }, params));
      revealCode(offerEl);
      showStatus(offerEl, applied ? cfg.msgApplied : cfg.msgFallback, !applied);
      cta.removeAttribute('aria-busy');
      cta.classList.remove('is-busy');
      scrollToPicks(offerEl);
      // Attribution: the attribute travels with the cart onto the order.
      markCart(code, params.offer_id);
    });
  });

  /* ---------- Copy Code ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-dl-offer-copy]');
    if (!btn) return;
    var offerEl = btn.closest('[data-dl-offer]');
    var code = offerEl ? (offerEl.getAttribute('data-dl-offer-code') || '') : '';
    var done = function () {
      var label = btn.textContent;
      btn.textContent = btn.getAttribute('data-copied-label') || 'Copied';
      btn.classList.add('is-done');
      setTimeout(function () { btn.textContent = label; btn.classList.remove('is-done'); }, 2200);
      if (offerEl) track('copy', baseParams(offerEl));
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, function () { fallbackCopy(code, done); });
    } else {
      fallbackCopy(code, done);
    }
  });
  function fallbackCopy(text, done) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta);
      done();
    } catch (e) {}
  }

  /* ---------- 3. Adds to cart after interacting ---------- */
  if (typeof window.fetch === 'function') {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var p = origFetch.apply(this, arguments);
      if (url.indexOf('/cart/add') !== -1) {
        p.then(function (res) {
          var state = readState();
          if (!state || !res || !res.ok) return;
          try {
            res.clone().json().then(function (data) {
              var items = Array.isArray(data.items) ? data.items : [data];
              items.forEach(function (it) {
                track('add_to_cart', {
                  offer_id: state.offerId, discount_code: state.code, offer_variant: 'page',
                  product_id: it.product_id, variant_id: it.variant_id || it.id, handle: it.handle,
                  quantity: it.quantity, price: typeof it.price === 'number' ? it.price / 100 : undefined,
                  currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
                });
              });
            }).catch(function () {});
          } catch (e) {}
        }).catch(function () {});
      }
      return p;
    };
  }

  /* If the reader arrived back from the non-JS /discount link, show the code and a status. */
  if (location.hash && /-products$|first-order-offer/.test(location.hash)) {
    offers.forEach(function (el) {
      var code = el.getAttribute('data-dl-offer-code') || '';
      if (hasDiscountCookie(code)) {
        revealCode(el);
        showStatus(el, cfg.msgApplied, false);
        if (!readState()) writeState({ code: code, offerId: baseParams(el).offer_id, at: Date.now() });
      }
    });
  }
})();
